<template>
  <div>
    <div>
      <div class="tabs" v-bind:class="[type]">
        <ul>
          <li
            class="ut-m-0"
            v-for="tab in tabs"
            :key="tab.name"
            :class="{ 'is-active': tab.isActive, 'new': tab.new }"
          >
            <a
              :href="tab.href"
              class="ga-event"
              :data-category="gacategory">
              <img v-if="tab.icon" :src="tab.icon">
              {{ tab.name }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="ut-h-full">
      <div class="tabs-details ut-pt-4 md:ut-pt-10">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    type: {
      type: String,
      required: false,
      default: 'default',
    },
    gacategory: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      tabs: [],
    };
  },
  computed: {
    selectedTab() {
      return this.tabs.find(tab => tab.href === this.$route.hash);
    },
  },
  watch: {
    $route() {
      if (this.selectedTab) {
        this.selectTab(this.selectedTab);
      }
    },
  },
  mounted() {
    if (this.selectedTab) {
      this.selectTab(this.selectedTab);
    }
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    getGaCategory(cat) {
      return cat || 'Tabs';
    },
    getGaAction(action, name) {
      return action || `Click Tab - ${name}`;
    },
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = tab.href === selectedTab.href;
      });

      this.$emit('changeTabs', selectedTab.name);

      if (selectedTab.gapageview) {
        this.$helpers.gaPageView(selectedTab.gapageview);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tabs {
  @apply ut-flex ut-justify-between;
  @apply ut-items-stretch ut-overflow-hidden;
  @apply ut-overflow-x-auto ut-whitespace-no-wrap ut-scrolling-touch;

  ul {
    // display: -webkit-box;

    @apply ut-justify-start ut-items-center ut-max-w-full ut-flex;

    @screen md {
      @apply ut-flex ut-flex-grow ut-flex-shrink-0 ut-flex-wrap;
    }
  }

  li {
    @apply ut-block ut-relative ut-pr-8;

    @screen md {
      @apply ut-pr-12;
    }

    &.new {
      &:after {
        @apply ut-top-0 ut-uppercase;
        content: "new";

        width: 37px;
        border-radius: 8px;
        background-color: #f32212;
        color: #ffffff;
        font-size: 8px;
        font-weight: bold;
        letter-spacing: 0.2px;
        line-height: 14px;
        text-align: center;
        position: absolute;
        right: 3rem;
      }
    }
  }

  a {
    @apply ut-items-center ut-flex ut-justify-center ut-align-top ut-py-4;
    //@apply ut-px-8 ut-py-4 ;
    margin-bottom: -1px;
    color: #464646;
    opacity: 0.6;

    img {
      @apply ut-mr-3 ut-ml-0;
    }
  }

  .is-active a {
    @apply ut-border-b-4 ut-border-green-400;
    color: #121212;
    opacity: 1;
  }

  &.full-width {
    ul {
      @apply ut-flex-no-wrap ut-flex ut-justify-start ut-items-center ut-w-full;

      li {
        @apply ut-w-full ut-h-full ut-px-0;
        border: 1px solid #d5d4d3;
        background-color: rgba(224, 222, 220, 0.19);
        border-right: none;

        &:last-child {
          border-right: 1px solid #d5d4d3;
        }

        &.is-active {
          @apply ut-border-b-0 ut-bg-transparent;
          border-top-color: #11ab5e;

          a {
            @apply ut-border-b-0 ut-border-t-4 ut-border-green-400;
          }
        }
      }
    }
  }
}
</style>
